import '@babel/polyfill'
import Shuffle from 'shufflejs'

Shuffle.ShuffleItem.Scale.HIDDEN = 1

function init(el) {
  const { filters } = el.dataset
  const filterButtons = el.querySelectorAll('[data-filter-button]')
  const container = el.querySelector('[data-filters-grid]')
  let shuffle

  // eslint-disable-next-line default-case
  switch (filters) {
    case 'media-center':
      shuffle = new Shuffle(container, {
        itemSelector: '.media-item',
        sizer: container.querySelector('.my-sizer-element'),
        gutterWidth: 32,
      })
  }

  function onClick(e) {
    const btn = e.currentTarget
    filterButtons.forEach(item => item.classList.remove('is-active'))
    btn.classList.add('is-active')
    shuffle.filter(btn.dataset.group)
  }

  filterButtons.forEach(button => {
    button.addEventListener('click', onClick, false)
  })
}

export default function() {
  const container = document.querySelector('[data-filters]')

  if (container) {
    window.addEventListener('load', () => {
      document.querySelectorAll('[data-filters]').forEach(init)
    })
  }
}
